(function () {
  function syncFooterNav() {
    var wide = window.matchMedia('(min-width: 900px)').matches;
    document.querySelectorAll('.bp-ft__nav').forEach(function (details) {
      if (wide) {
        details.setAttribute('open', '');
      } else if (!details.dataset.bpFtTouched) {
        details.removeAttribute('open');
      }
    });
  }

  function initFooterNav() {
    document.querySelectorAll('.bp-ft__nav').forEach(function (details) {
      details.addEventListener('toggle', function () {
        if (!window.matchMedia('(min-width: 900px)').matches) {
          details.dataset.bpFtTouched = 'true';
        }
      });
    });
    syncFooterNav();
    window.addEventListener('resize', syncFooterNav);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initFooterNav);
  } else {
    initFooterNav();
  }

  document.addEventListener('shopify:section:load', function (event) {
    if (event.target && event.target.querySelector('.bp-ft')) initFooterNav();
  });
})();
